import React, { createContext, useContext } from 'react';

const UserContext = createContext(null);

export const UserProvider = ({ children, value }) => {
  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export const useUser = () => {
  const context = useContext(UserContext);
  return context;
};

export default UserContext;